module.exports = __webpack_public_path__ + "images/single-house-icon-a1ab4913531fc0d1d53acc84ac63094d.svg";